(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Blakora-artifact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function lerp(a, b, t) { return a + (b - a) * t; }
    function smoothstep(t) { return t * t * (3 - 2 * t); }
    function prefersReducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

    function warpRotationFull(angleDeg) {
      var shifted = ((angleDeg - 90) % 360 + 360) % 360;
      var half = Math.floor(shifted / 180);
      var t = (shifted % 180) / 180;
      return half * 180 + 180 * smoothstep(t);
    }

    var ringFontFamily = null;
    function getRingFontFamily() {
      if (ringFontFamily) return ringFontFamily;
      var probe = document.querySelector('.bas-section');
      ringFontFamily = probe
        ? getComputedStyle(probe).getPropertyValue('--bas-ring-font-family').trim() || 'Helvetica, Arial, sans-serif'
        : 'Helvetica, Arial, sans-serif';
      return ringFontFamily;
    }

    function getPerformanceLevel(perfMode) {
      if (perfMode === 'auto') {
        var cores = navigator.hardwareConcurrency || 2;
        var mem = navigator.deviceMemory || 4;
        if (prefersReducedMotion()) return 'battery';
        if (cores >= 8 && mem >= 8) return 'ultra';
        if (cores >= 4 && mem >= 4) return 'high';
        if (cores >= 2 && mem >= 2) return 'balanced';
        return 'low';
      }
      return perfMode;
    }

    function buildRing(backLayer, frontLayer, texts, radiusX, radiusZ, fontPx, initialOffset) {
      if (!backLayer || !frontLayer) return { render: function () {}, stop: function () {} };

      var DOT = '\u2022';
      fontPx = fontPx || 32;
      var fontFamily = getRingFontFamily();
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var TIGHTEN = 1.1;

      ctx.font = '900 ' + fontPx + 'px ' + fontFamily;
      var unitNaturalWidth = 0;
      for (var p = 0; p < texts.length; p++) unitNaturalWidth += ctx.measureText(texts[p].toUpperCase()).width * TIGHTEN;
      unitNaturalWidth += texts.length * (fontPx * 0.45 + fontPx * 0.64);
      var circumference = 2 * Math.PI * ((radiusX + radiusZ) / 2);
      var REPEAT = Math.max(1, Math.round(circumference / unitNaturalWidth));

      var stream = [];
      for (var r = 0; r < REPEAT; r++) {
        for (var t = 0; t < texts.length; t++) {
          var word = texts[t];
          for (var c = 0; c < word.length; c++) stream.push({ ch: word[c], isDot: false });
          stream.push({ ch: ' ', isDot: false });
          stream.push({ ch: DOT, isDot: true });
          stream.push({ ch: ' ', isDot: false });
        }
      }
      stream.reverse();

      var widths = stream.map(function (s) {
        if (s.ch === ' ') return fontPx * 0.32;
        ctx.font = (s.isDot ? '700 ' + (fontPx * 0.45) : '900 ' + fontPx) + 'px ' + fontFamily;
        return ctx.measureText(s.ch.toUpperCase()).width * TIGHTEN;
      });
      var totalWidth = widths.reduce(function (a, b) { return a + b; }, 0);

      var letters = [];
      var acc = 0;
      for (var i = 0; i < stream.length; i++) {
        var lw = widths[i];
        var baseAngle = ((acc + lw / 2) / totalWidth) * 360;
        acc += lw;
        if (stream[i].ch === ' ') continue;

        var span = document.createElement('span');
        span.className = 'bas-ring-item' + (stream[i].isDot ? ' bas-ring-dot' : '');
        span.textContent = stream[i].ch;
        span.style.fontSize = (stream[i].isDot ? (fontPx * 0.45) : fontPx) + 'px';
        backLayer.appendChild(span);
        letters.push({ el: span, baseAngle: baseAngle, inFront: false });
      }

      var offsetStart = initialOffset || 0;

      function render(offset) {
        var totalOffset = offset + offsetStart;
        for (var j = 0; j < letters.length; j++) {
          var L = letters[j];
          var angle = L.baseAngle + totalOffset;
          var rad = (angle * Math.PI) / 180;
          var x = Math.cos(rad) * radiusX;
          var z = Math.sin(rad) * radiusZ;

          var depth = z / radiusZ;
          var depthT = (depth + 1) / 2;
          var extraScale = lerp(0.85, 1.05, depthT);
          var opacity = lerp(0.28, 1, depthT);
          var faceRotation = -warpRotationFull(angle);

          L.el.style.transform = 'translate3d(' + x + 'px, 0, ' + z + 'px) translate(-50%, -50%) rotateY(' + faceRotation + 'deg) scale(' + extraScale + ')';
          L.el.style.opacity = opacity;

          var shouldBeFront = z >= 0;
          if (shouldBeFront !== L.inFront) {
            L.inFront = shouldBeFront;
            (shouldBeFront ? frontLayer : backLayer).appendChild(L.el);
          }
        }
      }

      render(0);

      return {
        render: render,
        stop: function () {
          backLayer.innerHTML = '';
          frontLayer.innerHTML = '';
        }
      };
    }

    function initSection(section) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var perfMode = section.dataset.perf || 'auto';
      var qualityLevel = getPerformanceLevel(perfMode);

      var config = {
        radiusX: Number(isMobile ? section.dataset.basRadiusXM : section.dataset.basRadiusX) || 210,
        radiusZ: Number(isMobile ? section.dataset.basRadiusZM : section.dataset.basRadiusZ) || 95,
        speed: Number(isMobile ? section.dataset.basSpeedM : section.dataset.basSpeed) || 45,
        fontPx: Number(isMobile ? section.dataset.basFontM : section.dataset.basFont) || 32,
        rotationOffset: Number(isMobile ? section.dataset.basRotationOffsetM : section.dataset.basRotationOffset) || 0,
        second: {
          fontPx: Number(isMobile ? section.dataset.basSecondFontM : section.dataset.basSecondFont) || 32,
          speed: Number(isMobile ? section.dataset.basSecondSpeedM : section.dataset.basSecondSpeed) || 45,
          radiusX: Number(isMobile ? section.dataset.basSecondRadiusXM : section.dataset.basSecondRadiusX) || 210,
          radiusZ: Number(isMobile ? section.dataset.basSecondRadiusZM : section.dataset.basSecondRadiusZ) || 95,
          rotationOffset: Number(isMobile ? section.dataset.basSecondRotationOffsetM : section.dataset.basSecondRotationOffset) || 0
        }
      };

      var tileObservers = [];
      var renderers = [];
      var speeds = [];
      var tileInfoMap = new Map();

      var tiles = section.querySelectorAll('[data-bas-tile]');
      tiles.forEach(function (tile) {
        tileInfoMap.set(tile, { built: false, renderers: [], speeds: [], active: false });
      });

      function buildTile(tile) {
        var info = tileInfoMap.get(tile);
        if (info.built) {
          // Already built once — RESUME, don't rebuild. This is the fix
          // for scroll flicker: earlier this branch didn't exist (or
          // reset `built` to false on every scroll-out), which meant a
          // tile's ring DOM got fully destroyed and recreated — canvas
          // text measuring, letter-by-letter DOM creation — every single
          // time it crossed the rootMargin edge while scrolling. Letters
          // stay in the DOM permanently once built; resuming just re-adds
          // the already-built renderers to the active animation loop.
          if (!info.active) {
            info.renderers.forEach(function (r, idx) {
              renderers.push(r);
              speeds.push(info.speeds[idx]);
            });
            info.active = true;
          }
          return;
        }
        info.built = true;

        var reverse = tile.getAttribute('data-bas-reverse') === 'true';
        var reverseSecondary = tile.getAttribute('data-bas-reverse-secondary') === 'true';
        var text = tile.dataset.basText || 'BLAKORA';
        var secondText = tile.dataset.basSecondText || '';

        var mainBack = tile.querySelector('[data-bas-ring="main-back"]');
        var mainFront = tile.querySelector('[data-bas-ring="main-front"]');
        var mainSpeed = reverse ? -config.speed : config.speed;
        var tileRenderers = [];
        var tileSpeeds = [];

        if (mainBack && mainFront) {
          var r1 = buildRing(mainBack, mainFront, [text], config.radiusX, config.radiusZ, config.fontPx, config.rotationOffset);
          tileRenderers.push(r1);
          tileSpeeds.push(mainSpeed);
        }

        if (secondText) {
          var secondBack = tile.querySelector('[data-bas-ring="second-back"]');
          var secondFront = tile.querySelector('[data-bas-ring="second-front"]');
          if (secondBack && secondFront) {
            var r2 = buildRing(secondBack, secondFront, [secondText], config.second.radiusX, config.second.radiusZ, config.second.fontPx, config.second.rotationOffset);
            tileRenderers.push(r2);
            tileSpeeds.push(reverseSecondary ? -config.second.speed : config.second.speed);
          }
        }

        tile.classList.add('bas-tile-ready');
        info.renderers = tileRenderers;
        info.speeds = tileSpeeds;
        tileRenderers.forEach(function (r, idx) {
          renderers.push(r);
          speeds.push(tileSpeeds[idx]);
        });
        info.active = true;
        if (!section.classList.contains('bas-visible')) {
          section.classList.add('bas-visible');
        }
      }

      function unbuildTile(tile) {
        var info = tileInfoMap.get(tile);
        if (!info.built || !info.active) return;
        info.active = false;
        // PAUSE only — remove from the active rAF render loop so an
        // off-screen tile stops costing CPU/GPU work, but never touch
        // its DOM (no r.stop(), no innerHTML clearing, no resetting
        // `built`). The ring letters simply sit still, invisibly, until
        // this tile scrolls back into view and buildTile() resumes them
        // instantly with zero rebuild cost — no pop-in, no flicker.
        info.renderers.forEach(function (r) {
          var idx = renderers.indexOf(r);
          if (idx !== -1) {
            renderers.splice(idx, 1);
            speeds.splice(idx, 1);
          }
        });
      }

      var observerOptions = { rootMargin: '600px 0px', threshold: 0 };
      var pendingBuildTimers = new Map();
      // Bug fix: staggering used to be keyed off each tile's fixed grid
      // index (tile #5 always waited ~240ms even scrolled to on its own,
      // with nothing else building). Stagger now keys off how many builds
      // are ACTUALLY queued in the current burst — a lone tile entering
      // view during normal scroll builds instantly; only a genuine burst
      // (e.g. several tiles appearing at once on first load) gets spread
      // across frames.
      var burstCount = 0;
      var burstResetTimer = null;
      function queueBuild(tile) {
        var delay = Math.min(burstCount * 60, 240);
        burstCount++;
        clearTimeout(burstResetTimer);
        burstResetTimer = setTimeout(function () { burstCount = 0; }, 300);
        if (delay === 0) {
          buildTile(tile);
        } else {
          var timerId = setTimeout(function () {
            pendingBuildTimers.delete(tile);
            buildTile(tile);
          }, delay);
          pendingBuildTimers.set(tile, timerId);
        }
      }
      tiles.forEach(function (tile) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var info = tileInfoMap.get(tile);
              if (info.active || pendingBuildTimers.has(tile)) return;
              if (info.built) {
                // Already built, just paused — resume immediately. This
                // is free (no DOM work), so it never needs the staggered
                // queue, which exists only to spread out expensive FIRST
                // builds.
                buildTile(tile);
              } else {
                queueBuild(tile);
              }
            } else {
              if (pendingBuildTimers.has(tile)) {
                clearTimeout(pendingBuildTimers.get(tile));
                pendingBuildTimers.delete(tile);
              }
              var info = tileInfoMap.get(tile);
              if (info.built && info.active) {
                unbuildTile(tile);
              }
            }
          });
        }, observerOptions);
        observer.observe(tile);
        tileObservers.push(observer);
      });

      var paused = prefersReducedMotion() || document.hidden;
      var rafId = null;
      var startTime = performance.now();
      var elapsedAtPause = 0;
      var frameCounter = 0;
      var lastFrameTime = 0;
      var qualityLevelCurrent = qualityLevel;

      function tick(time) {
        if (paused) { rafId = null; return; }

        var delta = time - lastFrameTime;
        lastFrameTime = time;

        var skip = 1;
        if (qualityLevelCurrent === 'battery') skip = 3;
        else if (qualityLevelCurrent === 'low') skip = 2;
        else if (qualityLevelCurrent === 'balanced') skip = 2;

        if (qualityLevelCurrent !== 'ultra' && delta < 12) {
          skip = Math.ceil(16 / delta);
        }

        frameCounter++;
        if (frameCounter % skip !== 0) {
          rafId = requestAnimationFrame(tick);
          return;
        }

        var elapsed = (time - startTime) / 1000;
        for (var i = 0; i < renderers.length; i++) {
          renderers[i].render((elapsed * speeds[i]) % 360);
        }

        rafId = requestAnimationFrame(tick);
      }

      function pauseAll() {
        if (paused) return;
        paused = true;
        elapsedAtPause = (performance.now() - startTime) / 1000;
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      }
      function resumeAll() {
        if (!paused || prefersReducedMotion()) return;
        paused = false;
        startTime = performance.now() - elapsedAtPause * 1000;
        lastFrameTime = 0;
        if (!rafId) rafId = requestAnimationFrame(tick);
      }

      function handleVisibilityChange() {
        if (document.hidden) pauseAll(); else resumeAll();
      }
      document.addEventListener('visibilitychange', handleVisibilityChange);

      if (!paused) rafId = requestAnimationFrame(tick);
      section._basIsMobile = isMobile;

      return function destroy() {
        if (rafId) cancelAnimationFrame(rafId);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        tileObservers.forEach(function (obs) { obs.disconnect(); });
        pendingBuildTimers.forEach(function (timerId) { clearTimeout(timerId); });
        pendingBuildTimers.clear();
        clearTimeout(burstResetTimer);
        renderers.forEach(function (r) { r.stop(); });
      };
    }

    function initLazy(section) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            var destroy = initSection(section);
            section._basDestroy = destroy;
          }
        });
      }, { rootMargin: '300px' });
      observer.observe(section);
      return observer;
    }

    var sections = [];
    function boot() {
      document.querySelectorAll('.bas-section:not([data-bas-ready])').forEach(function (section) {
        section.setAttribute('data-bas-ready', 'true');
        var observer = initLazy(section);
        sections.push({ section: section, observer: observer });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);

    document.addEventListener('shopify:section:unload', function (e) {
      var idx = sections.findIndex(function (item) { return item.section === e.target; });
      if (idx !== -1) {
        if (sections[idx].section._basDestroy) {
          sections[idx].section._basDestroy();
        }
        if (sections[idx].observer) {
          sections[idx].observer.disconnect();
        }
        sections.splice(idx, 1);
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nowMobile = window.matchMedia('(max-width: 749px)').matches;
        sections.forEach(function (item) {
          var section = item.section;
          if (section._basIsMobile === nowMobile) return;
          if (section._basDestroy) {
            section._basDestroy();
          }
          if (item.observer) {
            item.observer.disconnect();
          }
          var newObserver = initLazy(section);
          item.observer = newObserver;
        });
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Blakora-product-hotspot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (ROOT.slice(-1) === '/') ROOT = ROOT.slice(0, -1);

    function fmtMoney(cents) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return currency + ' ' + (cents / 100).toFixed(2); }
    }

    function patchCartBadges(cart) {
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
      if (count === null) return;
      ['.cart-count-bubble', '[data-cart-count]', '#cart-icon-bubble', '.cart-count', '[data-cart-item-count]', '[ref="cartBubbleCount"]']
        .forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.textContent = count;
            if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
          });
        });
    }

    function findCartDrawerSectionId() {
      var el = document.querySelector('cart-items-component[data-drawer]');
      return el ? el.getAttribute('data-section-id') : null;
    }

    function swapSectionHtml(sectionId, html) {
      if (!sectionId || !html) return;
      var wrapper = document.getElementById('shopify-section-' + sectionId);
      if (!wrapper) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + sectionId) || doc.body.firstElementChild;
      if (fresh) wrapper.innerHTML = fresh.innerHTML;
    }

    function isTouchDevice() { return window.matchMedia('(hover: none), (pointer: coarse)').matches; }
    function prefersReducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

    function openDialog(dialog) {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      var focusable = dialog.querySelector('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    }
    function closeDialog(dialog) {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    }

    /* ── One hotspot = one self-contained panel: price/stock/sizes/add-to-cart,
       all driven from the JSON this same element ships with. No fetch, no
       second dialog for cart. The image-click gallery is a separate, simple
       lightbox — opening it never affects the cart panel. ── */
    function HotspotMarker() {
      var el = this;
      el.trigger = el.querySelector('.sph-trigger');
      el.preview = el.querySelector('.sph-preview');
      if (!el.preview) return; // product-less hotspot — nothing to wire up

      var dataNode = el.preview.querySelector('.sph-variant-data');
      var data = { initial: [], variants: {} };
      try { data = JSON.parse(dataNode.textContent); } catch (e) { /* leave defaults */ }

      var selected = data.initial.slice();
      var currentVariant = null;
      var openTimer = null;
      var closeTimer = null;

      var priceEl = el.preview.querySelector('[data-sph-price]');
      var stockEl = el.preview.querySelector('[data-sph-stock]');
      var stockTextEl = el.preview.querySelector('[data-sph-stock-text]');
      var addBtn = el.preview.querySelector('[data-sph-add]');
      var addLabelEl = el.preview.querySelector('[data-sph-add-label]');
      var statusEl = el.preview.querySelector('[data-sph-status]');
      var defaultLabel = addLabelEl ? addLabelEl.textContent : 'Add to Bag';
      var pills = el.preview.querySelectorAll('.sph-pill');

      function matchVariant() {
        return data.variants[selected.join('||')] || null;
      }

      function renderCurrent(animate) {
        currentVariant = matchVariant();
        var doFade = animate && !prefersReducedMotion();

        function applyPrice() {
          if (priceEl && currentVariant) {
            var html = fmtMoney(currentVariant.price);
            if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
              html += ' <span class="sph-preview__compare">' + fmtMoney(currentVariant.compare_at_price) + '</span>';
            }
            priceEl.innerHTML = html;
          }
        }

        function applyStock() {
          if (stockEl && stockTextEl) {
            var available = !!(currentVariant && currentVariant.available);
            stockEl.classList.toggle('is-out', !available);
            if (!currentVariant) stockTextEl.textContent = 'Unavailable';
            else if (!available) stockTextEl.textContent = 'Sold Out';
            else if (currentVariant.tracked && typeof currentVariant.qty === 'number' && currentVariant.qty > 0 && currentVariant.qty <= 5) {
              stockTextEl.textContent = 'Only ' + currentVariant.qty + ' left';
            } else {
              stockTextEl.textContent = 'In Stock';
            }
          }
        }

        if (doFade) {
          if (priceEl) priceEl.style.opacity = '0';
          if (stockEl) stockEl.style.opacity = '0';
          setTimeout(function () {
            applyPrice();
            applyStock();
            if (priceEl) priceEl.style.opacity = '1';
            if (stockEl) stockEl.style.opacity = '1';
          }, 130);
        } else {
          applyPrice();
          applyStock();
        }

        if (addBtn && addLabelEl) {
          if (currentVariant && currentVariant.available) {
            addBtn.disabled = false;
            addLabelEl.textContent = defaultLabel;
          } else {
            addBtn.disabled = true;
            addLabelEl.textContent = currentVariant ? 'Sold Out' : 'Unavailable';
          }
        }

        pills.forEach(function (pill) {
          var idx = Number(pill.dataset.optionIndex);
          var probe = selected.slice();
          probe[idx] = pill.dataset.value;
          var v = data.variants[probe.join('||')];
          var available = !!(v && v.available);
          pill.classList.toggle('is-sold-out', !available);
          if (pill.getAttribute('role') === 'radio') {
            pill.setAttribute('aria-checked', pill.classList.contains('is-active') ? 'true' : 'false');
          }
        });
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('is-sold-out')) return;
          var idx = Number(pill.dataset.optionIndex);
          el.preview.querySelectorAll('.sph-pill[data-option-index="' + idx + '"]').forEach(function (p) {
            p.classList.remove('is-active');
            if (p.getAttribute('role') === 'radio') p.setAttribute('aria-checked', 'false');
          });
          pill.classList.add('is-active');
          if (pill.getAttribute('role') === 'radio') pill.setAttribute('aria-checked', 'true');
          selected[idx] = pill.dataset.value;
          statusEl.textContent = '';
          renderCurrent(true);
        });
      });

      function addToCart() {
        if (!currentVariant || !currentVariant.available) return;
        addBtn.disabled = true;
        addLabelEl.textContent = 'Adding…';
        statusEl.textContent = '';

        var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timeoutId = controller ? setTimeout(function () { controller.abort(); }, 6000) : null;

        var drawerSectionId = findCartDrawerSectionId();
        var payload = { items: [{ id: currentVariant.id, quantity: 1 }] };
        if (drawerSectionId) { payload.sections = drawerSectionId; payload.sections_url = window.location.pathname; }

        fetch(ROOT + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          signal: controller ? controller.signal : undefined
        })
          .then(function (r) { if (timeoutId) clearTimeout(timeoutId); if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'add failed'); }); return r.json(); })
          .then(function (cartAddResult) {
            addLabelEl.textContent = 'Added';
            statusEl.textContent = 'Added to cart.';

            if (drawerSectionId && cartAddResult && cartAddResult.sections && cartAddResult.sections[drawerSectionId]) {
              swapSectionHtml(drawerSectionId, cartAddResult.sections[drawerSectionId]);
            }
            fetch(ROOT + '/cart.js').then(function (r) { return r.json(); })
              .then(function (c) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: c })); patchCartBadges(c); });

            clearTimeout(closeTimer);
            closeTimer = setTimeout(function () {
              closePreview();
              addBtn.disabled = false;
              addLabelEl.textContent = defaultLabel;
              statusEl.textContent = '';
            }, 900);
          })
          .catch(function (err) {
            if (timeoutId) clearTimeout(timeoutId);
            var timedOut = err && err.name === 'AbortError';
            statusEl.textContent = timedOut ? 'Taking too long — try again.' : (err && err.message ? err.message : 'Could not add to cart.');
            addBtn.disabled = false;
            addLabelEl.textContent = defaultLabel;
          });
      }
      addBtn.addEventListener('click', addToCart);

      /* ── open/close + boundary-aware positioning ── */
      function openPreview() {
        var preview = el.preview;
        preview.removeAttribute('inert');
        preview.classList.remove('is-flipped');
        preview.style.setProperty('--sph-shift-x', '0px');
        preview.style.setProperty('--sph-shift-y', '0px');

        var prevTransition = preview.style.transition;
        var prevVisibility = preview.style.visibility;
        preview.style.transition = 'none';
        preview.style.visibility = 'hidden';
        preview.classList.add('is-open');
        preview.getBoundingClientRect();

        var container = el.closest('.sph-hotspots');
        if (container) {
          var containerRect = container.getBoundingClientRect();
          var rect = preview.getBoundingClientRect();

          if (rect.bottom > containerRect.bottom - 8 && rect.top - rect.height > containerRect.top + 8) {
            preview.classList.add('is-flipped');
            rect = preview.getBoundingClientRect();
          }

          var shiftX = 0;
          if (rect.left < containerRect.left + 8) shiftX = (containerRect.left + 8) - rect.left;
          else if (rect.right > containerRect.right - 8) shiftX = (containerRect.right - 8) - rect.right;
          if (shiftX) preview.style.setProperty('--sph-shift-x', shiftX + 'px');

          var shiftY = 0;
          if (rect.top < containerRect.top + 8) shiftY = (containerRect.top + 8) - rect.top;
          else if (rect.bottom > containerRect.bottom - 8) shiftY = (containerRect.bottom - 8) - rect.bottom;
          if (shiftY) preview.style.setProperty('--sph-shift-y', shiftY + 'px');
        }

        preview.classList.remove('is-open');
        preview.style.visibility = prevVisibility;
        preview.getBoundingClientRect();
        preview.style.transition = prevTransition;

        requestAnimationFrame(function () {
          preview.classList.add('is-open');
          el.trigger.setAttribute('aria-expanded', 'true');
        });
      }

      function closePreview() {
        el.preview.classList.remove('is-open');
        el.preview.setAttribute('inert', '');
        el.trigger.setAttribute('aria-expanded', 'false');
      }

      el.trigger.addEventListener('click', function () {
        if (el.preview.classList.contains('is-open')) closePreview(); else openPreview();
      });

      if (!isTouchDevice()) {
        el.trigger.addEventListener('pointerenter', function () {
          clearTimeout(openTimer);
          openTimer = setTimeout(openPreview, 120);
        });
        el.addEventListener('pointerleave', function () {
          clearTimeout(openTimer);
          setTimeout(function () { if (!el.matches(':hover')) closePreview(); }, 60);
        });
      }

      var closeBtn = el.preview.querySelector('[data-sph-close]');
      if (closeBtn) closeBtn.addEventListener('click', closePreview);

      document.addEventListener('click', function (e) {
        if (!el.contains(e.target)) closePreview();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePreview();
      });

      /* ── Gallery lightbox with horizontal carousel ── */
      var galleryDialog = el.querySelector('.sph-gallery');
      var galleryOpenBtn = el.preview.querySelector('[data-sph-gallery-open]');
      if (galleryDialog && galleryOpenBtn) {
        galleryOpenBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          // Reset scroll to first image
          var track = galleryDialog.querySelector('.sph-gallery__track');
          if (track) track.scrollLeft = 0;
          openDialog(galleryDialog);
        });

        var closeGalleryBtn = galleryDialog.querySelector('[data-sph-gallery-close]');
        if (closeGalleryBtn) closeGalleryBtn.addEventListener('click', function () { closeDialog(galleryDialog); });
        galleryDialog.addEventListener('click', function (e) {
          if (e.target === galleryDialog) closeDialog(galleryDialog);
        });

        // Arrow navigation
        var prevBtn = galleryDialog.querySelector('[data-sph-gallery-prev]');
        var nextBtn = galleryDialog.querySelector('[data-sph-gallery-next]');
        var track = galleryDialog.querySelector('.sph-gallery__track');

        function scrollTrack(dir) {
          if (!track) return;
          var scrollAmount = track.clientWidth * 0.9; // scroll by almost full width
          track.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { scrollTrack(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { scrollTrack(1); });

        // Keyboard arrows inside dialog
        galleryDialog.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); scrollTrack(-1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); scrollTrack(1); }
        });
      }

      renderCurrent(false);

      /* ── Gallery dot indicators: keep active dot synced with scroll ── */
      var dotsWrap = el.querySelector('[data-sph-gallery-dots]');
      if (galleryDialog && dotsWrap) {
        var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.sph-gallery__dot'));
        var dotsTrack = galleryDialog.querySelector('.sph-gallery__track');
        var dotsTicking = false;

        function updateActiveDot() {
          if (!dotsTrack || !dots.length) return;
          var width = dotsTrack.clientWidth || 1;
          var idx = Math.round(dotsTrack.scrollLeft / width);
          idx = Math.max(0, Math.min(dots.length - 1, idx));
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }

        if (dotsTrack) {
          dotsTrack.addEventListener('scroll', function () {
            if (dotsTicking) return;
            dotsTicking = true;
            requestAnimationFrame(function () { updateActiveDot(); dotsTicking = false; });
          }, { passive: true });
        }

        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            if (!dotsTrack) return;
            dotsTrack.scrollTo({ left: dotsTrack.clientWidth * i, behavior: 'smooth' });
          });
        });
      }
    }

    /* ── Staggered marker entrance — opt-in via JS so it degrades
       gracefully without JavaScript (markers stay visible by default). ── */
    function initRevealAnimation(section) {
      var layer = section.querySelector('.sph-hotspots');
      if (!layer) return;
      layer.classList.add('sph-hotspots--will-animate');
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              layer.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.2 });
        obs.observe(section);
      } else {
        layer.classList.add('is-visible');
      }
    }

    function boot() {
      document.querySelectorAll('.section-product-hotspots:not([data-sph-reveal-ready])').forEach(function (section) {
        section.setAttribute('data-sph-reveal-ready', 'true');
        initRevealAnimation(section);
      });
      document.querySelectorAll('.section-product-hotspots .sph-hotspot:not([data-sph-ready])').forEach(function (el) {
        el.setAttribute('data-sph-ready', 'true');
        HotspotMarker.call(el);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('#BlakoraPassword-{{ section.id }} .blakora-password__footer-password');
    if (!trigger) return;

    var field = document.getElementById('BlakoraPasswordInput-{{ section.id }}');
    if (!field) return;

    event.preventDefault();

    field.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    window.setTimeout(function () {
      try {
        field.focus({ preventScroll: true });
      } catch (error) {
        field.focus();
      }
    }, 300);
  });

  } catch(e) { console.error(e); }
})();
})();
